/**
 * src/i18n/services/SafeInterpolator.ts
 *
 * Safe token interpolator for translation strings.
 * Replaces `{token}` with sanitized string values, preventing raw HTML/XSS injection.
 */

export class SafeInterpolator {
  /**
   * Replaces `{token}` in template with corresponding param value after stripping HTML tags.
   */
  public static interpolate(
    template: string,
    params?: Record<string, string | number | boolean | null | undefined>
  ): string {
    if (!params || typeof template !== 'string') {
      return template || '';
    }

    return template.replace(/\{(\w+)\}/g, (match, key) => {
      if (Object.prototype.hasOwnProperty.call(params, key)) {
        const val = params[key];
        if (val === null || val === undefined) return '';
        // Sanitize string to prevent raw HTML execution
        return String(val).replace(/[<>]/g, '');
      }
      return match;
    });
  }
}
